// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3BAbJ","unreadBadge":"styles_unreadBadge__1GzmA","modalContent":"styles_modalContent__I0k_d","modal":"styles_modal__9xd97"};